import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import websocket from '@/util/websocket.js';
import { logoutDev } from "@/api/user";
import $ from 'jquery';
import website from '@/config/website';
import { serialize } from '@/util/util';
import { getToken, getRefreshToken } from '@/util/auth';
import { getStore } from '@/util/store';
export default {
  name: "app",
  data: function data() {
    return {
      beforeUnloadTime: '',
      gapTime: ''
    };
  },
  watch: {},
  computed: {},
  mounted: function mounted() {
    var _this = this;

    window.addEventListener('beforeunload', function (e) {
      return _this.beforeunloadHandler(e);
    }, false);
    window.addEventListener('unload', function (e) {
      return _this.unloadHandler(e);
    }, false);
  },
  beforeDestroy: function beforeDestroy() {},
  destroyed: function destroyed() {
    var _this2 = this;

    window.removeEventListener('beforeunload', function (e) {
      return _this2.beforeunloadHandler(e);
    });
    window.removeEventListener('unload', function (e) {
      return _this2.unloadHandler(e);
    });
  },
  created: function created() {// localStorage.setItem("clientId",this.$store.state.user.waylist)
    // if(typeof(websocket.getWebSocket())=="undefined"){
    //     websocket.Init(this.$store.state.user.waylist)
    // }
  },
  methods: {
    beforeunloadHandler: function beforeunloadHandler(e) {
      this.beforeUnloadTime = new Date().getTime(); // e = e || window.event
      // if(e){
      //   e.returnValue = "关闭提示"
      // }
      // return "关闭提示"
    },
    reportData: function reportData(url, data) {
      var img = document.createElement('img');
      var params = [];
      Object.keys(data).forEach(function (key) {
        params.push("".concat(key, "=").concat(encodeURIComponent(data[key])));
      });

      img.onload = function () {
        return img = null;
      };

      img.src = "".concat(url, "?").concat(params.join('&'));
    },
    unloadHandler: function unloadHandler(e) {
      this.gapTime = new Date().getTime() - this.beforeUnloadTime; //判断是窗口关闭还是刷新\

      if (this.gapTime <= 5) {
        var obj = {
          bladeAuth: "bearer ".concat(getToken()),
          tenantId: "".concat(getStore({
            name: 'tenantId'
          }) || ''),
          userId: getStore({
            name: 'userInfo'
          }).user_id
        },
            url = "http://heshanprod.thingcom.com/api/blade-auth/oauth/logout/dev";
        var formData = new FormData();
        Object.keys(obj).forEach(function (key) {
          var value = obj[key];

          if (typeof value != 'string') {
            value = JSON.stringify(value);
          }

          formData.append(key, value);
        });
        navigator.sendBeacon(url, formData);
      }
    }
  }
};